export default __webpack_public_path__ + "static/section_6_details_1-81635e54e0c7d93fc6ff030078456c78.png";